import {
  getOrderRefundability as publicGetOrderRefundability,
  calculateRefund as publicCalculateRefund,
  refundPayments as publicRefundPayments,
  authorizeChargeWithSavedPaymentMethod as publicAuthorizeChargeWithSavedPaymentMethod,
  voidAuthorizedPayments as publicVoidAuthorizedPayments,
  captureAuthorizedPayments as publicCaptureAuthorizedPayments,
  generateReceipts as publicGenerateReceipts,
} from './ecom-v1-order-billing-order-billing.public.js';
import { createRESTModule } from '@wix/sdk-runtime/rest-modules';
import { BuildRESTFunction, MaybeContext } from '@wix/sdk-types';

export const getOrderRefundability: MaybeContext<
  BuildRESTFunction<typeof publicGetOrderRefundability> &
    typeof publicGetOrderRefundability
> = /*#__PURE__*/ createRESTModule(publicGetOrderRefundability);
export const calculateRefund: MaybeContext<
  BuildRESTFunction<typeof publicCalculateRefund> & typeof publicCalculateRefund
> = /*#__PURE__*/ createRESTModule(publicCalculateRefund);
export const refundPayments: MaybeContext<
  BuildRESTFunction<typeof publicRefundPayments> & typeof publicRefundPayments
> = /*#__PURE__*/ createRESTModule(publicRefundPayments);
export const authorizeChargeWithSavedPaymentMethod: MaybeContext<
  BuildRESTFunction<typeof publicAuthorizeChargeWithSavedPaymentMethod> &
    typeof publicAuthorizeChargeWithSavedPaymentMethod
> = /*#__PURE__*/ createRESTModule(publicAuthorizeChargeWithSavedPaymentMethod);
export const voidAuthorizedPayments: MaybeContext<
  BuildRESTFunction<typeof publicVoidAuthorizedPayments> &
    typeof publicVoidAuthorizedPayments
> = /*#__PURE__*/ createRESTModule(publicVoidAuthorizedPayments);
export const captureAuthorizedPayments: MaybeContext<
  BuildRESTFunction<typeof publicCaptureAuthorizedPayments> &
    typeof publicCaptureAuthorizedPayments
> = /*#__PURE__*/ createRESTModule(publicCaptureAuthorizedPayments);
/** @internal */
export const generateReceipts: MaybeContext<
  BuildRESTFunction<typeof publicGenerateReceipts> &
    typeof publicGenerateReceipts
> = /*#__PURE__*/ createRESTModule(publicGenerateReceipts);

export {
  ManuallyRefundableReason,
  NonRefundableReason,
  RuleType,
  RefundStatus,
  TransactionStatus,
  AuthorizationCaptureStatus,
  AuthorizationVoidStatus,
  Reason,
  ActionType,
  MembershipPaymentStatus,
  ScheduledAction,
  DurationUnit,
} from './ecom-v1-order-billing-order-billing.universal.js';
export {
  OrderBilling,
  GetOrderRefundabilityRequest,
  GetOrderRefundabilityResponse,
  PaymentRefundability,
  PaymentRefundabilityStatusOneOf,
  PaymentInfo,
  PaymentInfoSummaryOneOf,
  PaymentInfoPaymentMethodDetailsOneOf,
  MonetaryPaymentSummary,
  Price,
  MembershipPaymentSummary,
  CreditCardPaymentMethodDetails,
  ManuallyRefundablePaymentStatus,
  NonRefundablePaymentStatus,
  PaymentsSummary,
  LineItemRefundability,
  ShippingRefundability,
  AdditionalFeeRefundability,
  CalculateRefundRequest,
  RefundItems,
  LineItemRefund,
  AdditionalFeeRefund,
  ShippingRefund,
  CalculateRefundResponse,
  CalculateRefundResponseStatusOneOf,
  AggregatedRefundSummary,
  CalculatedRefundItems,
  CalculatedLineItemRefund,
  CalculatedRefundSummary,
  CalculatedAdditionalFeeRefund,
  CalculatedShippingRefund,
  CalculatedRefundNotAvailableStatus,
  CalculationError,
  CalculationErrorItemOneOf,
  Details,
  DetailsKindOneOf,
  ApplicationError,
  ValidationError,
  FieldViolation,
  SystemError,
  RefundPaymentsRequest,
  PaymentRefund,
  RefundSideEffects,
  RestockItem,
  RestockSideEffects,
  NotificationSideEffects,
  RefundPaymentsResponse,
  Refund,
  RefundTransaction,
  RefundStatusInfo,
  RefundDetails,
  RefundItem,
  V1LineItemRefund,
  V1AdditionalFeeRefund,
  V1ShippingRefund,
  V1AggregatedRefundSummary,
  RefundItemsBreakdown,
  LineItemRefundSummary,
  OrderTransactions,
  Payment,
  PaymentPaymentDetailsOneOf,
  PaymentReceiptInfoOneOf,
  RegularPaymentDetails,
  RegularPaymentDetailsPaymentMethodDetailsOneOf,
  AuthorizationDetails,
  AuthorizationCapture,
  AuthorizationActionFailureDetails,
  AuthorizationVoid,
  V1ScheduledAction,
  GiftCardPaymentDetails,
  MembershipPaymentDetails,
  MembershipName,
  WixReceiptInfo,
  ExternalReceiptInfo,
  PaymentNotRefundableDetails,
  AuthorizeChargeWithSavedPaymentMethodRequest,
  DelayedCaptureSettings,
  Duration,
  AuthorizeChargeWithSavedPaymentMethodResponse,
  VoidAuthorizedPaymentsRequest,
  VoidAuthorizedPaymentsResponse,
  CaptureAuthorizedPaymentsRequest,
  PaymentCapture,
  CaptureAuthorizedPaymentsResponse,
  GenerateReceiptsRequest,
  GenerateReceiptsResponse,
  ReceiptInfo,
  DomainEvent,
  DomainEventBodyOneOf,
  EntityCreatedEvent,
  RestoreInfo,
  EntityUpdatedEvent,
  EntityDeletedEvent,
  ActionEvent,
  Empty,
  GetOrderRefundabilityResponseNonNullableFields,
  CalculateRefundResponseNonNullableFields,
  RefundPaymentsResponseNonNullableFields,
  AuthorizeChargeWithSavedPaymentMethodResponseNonNullableFields,
  VoidAuthorizedPaymentsResponseNonNullableFields,
  CaptureAuthorizedPaymentsResponseNonNullableFields,
  GenerateReceiptsResponseNonNullableFields,
  CalculateRefundOptions,
  RefundPaymentsOptions,
  AuthorizeChargeWithSavedPaymentMethodOptions,
  VoidAuthorizedPaymentsOptions,
  CaptureAuthorizedPaymentsOptions,
  GenerateReceiptsOptions,
} from './ecom-v1-order-billing-order-billing.universal.js';
